<template>
  <div class="yk-qw-content">
     <div class="clearfix manger-import-div">
       <div class="btn-back" @click="btnGoBack">{{clickCourseName}} /</div>
       <div style="float:right">
            题型：
            <el-select style="width:23%;margin-right:15px;"
                      v-model="queTypevalue"
                      slot="prepend"
                      @change="getQuestionListByPage(1)"
                      placeholder="请选择"
                      clearable>
              <el-option label="单选题"
                        value="1"></el-option>
              <el-option label="多选题"
                        value="2"></el-option>
              <el-option label="判断题"
                        value="3"></el-option>
              <el-option label="填空题"
                        value="4"></el-option>
              <el-option label="简答题"
                        value="5"></el-option>
              <el-option label="综合题"
                        value="6"></el-option>
            </el-select>
            难度：
            <el-select style="width:23%;margin-right:15px;"
                      v-model="diffTypeValue"
                      slot="prepend"
                      @change="getQuestionListByPage(1)"
                      placeholder="请选择"
                      clearable>
              <el-option label="简单"
                        value="1"></el-option>
              <el-option label="一般"
                        value="2"></el-option>
              <el-option label="困难"
                        value="3"></el-option>
            </el-select>
            知识点：
          <el-select style="width:23%" clearable filterable v-model="knowledgeId"
                     placeholder="请选择知识点" 
                     @change="getQuesPage">
            <el-option
              v-for="item in knowledgeLists"
              :key="item.knowledgeId"
              :label="item.KnowledgeName"
              :value="item.Id"
              >
            </el-option>
          </el-select>
      </div>
      </div>
    <el-container>
      <el-main>
        <el-table ref="multipleTable"
                  :data="questionLists"
                  tooltip-effect="dark"
                  style="width: 100%"
                  @selection-change="handleSelectionChangeDialog"
                  :row-key="getRowKeys">
          <el-table-column 
            :reserve-selection="true"
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column label="序号"
                           width="60"
                           type="index">
          </el-table-column>
          <el-table-column label="题干">
            <template slot-scope="scope">
              <span v-html="scope.row.content"></span>
            </template>
          </el-table-column>
          <el-table-column label="知识点">
            <template slot-scope="scope">
              <span v-if="scope.row.KnowledgeName==null">未设置知识点</span>
              <span v-if="scope.row.KnowledgeName!=null">{{scope.row.KnowledgeName}}</span>
            </template>           
          </el-table-column>
          <el-table-column label="题目类型"
                           prop="questionType">
          </el-table-column>
          <el-table-column label="题目难度"
                           prop="difficulty"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini"
              @click="setQuestionInfo(scope.row)"
              icon="wl-icon-chakan"
              type="primary"
              title="查看"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 题目详情 -->
        <el-dialog :title="questionInfo.QuestionType +'——' + questionInfo.Difficulty"
                  :visible.sync="queDetailDialogVisible"
                  width="50%"
                  :append-to-body="true"
                  :close-on-click-modal="false"
                  :close-on-press-escape="false"
                  v-if="queDetailDialogVisible">
          <Multiselect :IsTitle="false"
                      :IsSelects=-1
                      :IsAnswers="true"
                      :IsAnalysis="-1"
                      v-if="questionInfo.QuestionType === '单选题' || questionInfo.QuestionType == '多选题'"
                      :data="questionInfo" />
          <true-false :IsTitle="false"
                      :IsSelects=-1
                      :IsAnswers="true"
                      :IsAnalysis="-1"
                      v-else-if="questionInfo.QuestionType =='判断题'"
                      :data="questionInfo" />
          <fillInTheBlanks :IsTitle="false"
                          :IsSelects=-1
                          :IsAnswers="true"
                          :IsAnalysis="-1"
                          v-else-if="questionInfo.QuestionType =='填空题'"
                          :data="questionInfo" />
          <short-answer :IsTitle="false"
                        :IsSelects="false"
                        :IsAnswers="-1"
                        :IsAnalysis="-1"
                        v-else-if="questionInfo.QuestionType =='简答题'"
                        :data="questionInfo" />
          <SynthesisInfo :IsSelects=-1
                        :data="questionInfo"
                        :childQuestionList="childQuestionList"
                        v-else-if="questionInfo.QuestionType =='综合题'"></SynthesisInfo>
        </el-dialog>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="onPageChangeHandler"
                       :current-page="pageIndex"
                       :page-sizes="[10,50,100,200,500,1000]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"
                       v-show="total>0">
        </el-pagination>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Choice from 'components/ObjectiveTest/Choice.vue';
import FillInTheBlanks from 'components/ObjectiveTest/FillInTheBlanks.vue';
import Multiselect from 'components/ObjectiveTest/Multiselect.vue';
import TrueFalse from 'components/ObjectiveTest/TrueFalse.vue';
import ShortAnswer from 'components/SubjectiveTest/ShortAnswer.vue';
import SynthesisInfo from 'components/ObjectiveTest/SynthesisInfo.vue';
import {
  GetKnowledgeList
} from "api/v1.design.questionknowledge.ts";
import {
  GetCombineQuestionInfo
} from 'api/v1.desgin.shareQuestion.ts';
import {
  GetImportQuestionList
} from 'api/v1.design.importquestiontable.ts';
import {
  EditQuestion
} from 'api/v1.desgin.question.ts';
export default {
  name: 'ImportQuestionList',
  components: {
    Choice,
    TrueFalse,
    ShortAnswer,
    Multiselect,
    FillInTheBlanks,
    SynthesisInfo
  },
  props: {
    courseId: {
      type: String,
      default: ''
    },
    setData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      queTypevalue: '',
      diffTypeValue: '',
      active: '',
      // 被选中的值
      setData: [],
      // 接口数据
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      knowledgeLists: [],
      questionLists: [],
      type: ['', '单选题', '多选题', '判断题', '填空题', '简答题', '综合题'],
      difficult: ['', '简单', '一般', '困难'],
      knowledgeId: '',
      knowledgeName: '',
      queDetailDialogVisible: false,
      // 详情
      questionInfo: {
        Difficulty: '',
        QuestionType: '',
        ContentText: '',
        Selects: Array,
        Answers: Array,
        Analysis: '',
        stemFiles: Array,
        analysisFiles: Array
      },
      // 题干附件
      stemFiles: [],
      // 解析附件
      analysisFile: [],
      page: 1,
      totalCount: 0,
      notsetCount: 0,
      checkedbtn: true,
      checkbtn: false,
      // 获取row的key值
      getRowKeys(row) {
        return row.Id;
      },
      // 选中的行
      checkRow: [],
      isNumber: 0,
      clickCourseName: ''
    };
  },
  watch: {
    // checkRow: function(val) {
    //   debugger;
    //   this.setData = [];
    //   val.forEach(element => {
    //     this.setData.push(element.Id);
    //   });
    //   this.$emit('update:setData', this.setData);
    // },
    // isclear: function() {
    //   if (this.isclear === 1) {
    //     this.clearMembers();
    //   }
    // }
  },
  created() {
    console.log(this.courseId);
    this.getImportQuestionList();
    this.getKnowledgeList();
  },
  methods: {
    /// 清除弹窗中的选中值
    // clearMembers() {
    //   this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
    // },
    /* 获取题库数据 */
    getImportQuestionList: function() {
      this.checkedbtn = true;
      this.checkbtn = false;
      GetImportQuestionList(
        this.courseId,
        this.knowledgeId,
        this.queTypevalue,
        this.diffTypeValue,
        this.page,
        this.pageSize
      ).then(rst => {
        this.total = rst.pagination.totalCount;
        this.pageSize = rst.pagination.pageSize;
        this.pageIndex = rst.pagination.pageIndex;
        this.questionLists = rst.list;
        this.questionLists.forEach(element => {
          (element.questionType = this.type[element.questionType]),
          (element.difficulty = this.difficult[element.difficulty]);
        });
      });
    },
    //获取知识点列表
    getKnowledgeList: function (){
      GetKnowledgeList(this.courseId).then(rst=>{
        if (rst.code ==1){
          this.knowledgeLists = rst.knowledgeList
        }
      });
    },
    // 查看详情
    setQuestionInfo: function(questionLists) {
      this.questionInfo.Difficulty = questionLists.difficulty;
      this.questionInfo.QuestionType = questionLists.questionType;
      this.questionInfo.ContentText = questionLists.contentText;
      this.questionInfo.Selects = questionLists.selectContent;
      this.questionInfo.Answers = questionLists.answerContent;
      this.questionInfo.Analysis = questionLists.analysis;
      this.questionInfo.Content = questionLists.content;
      EditQuestion(questionLists.Id).then(rst => {
        if (rst.code > 0) {
          this.questionInfo.stemFiles = rst.stemFiles;
          this.questionInfo.analysisFiles = rst.analysisFile;
          this.queDetailDialogVisible = true;
        } else {
          this.$message.warning(rst.msg);
        }
      });
      if (questionLists.questionType === '综合题') {
        GetCombineQuestionInfo(questionLists.Id).then(rst => {
          if (rst.code > 0) {
            this.childQuestionList = rst.subQuestionList;
          } else {
            this.$message.warning(rst.msg);
          }
        });
      }
    },
    /* 获取题库数据 */
    getQuestionListByPage: function(page) {
      this.checkedbtn = true;
      this.checkbtn = false;
      GetImportQuestionList(
        this.courseId,
        this.knowledgeId,
        this.queTypevalue,
        this.diffTypeValue,
        page,
        this.pageSize
      ).then(rst => {
        this.total = rst.pagination.totalCount;
        this.pageSize = rst.pagination.pageSize;
        this.pageIndex = rst.pagination.pageIndex;
        this.questionLists = rst.list;
        this.questionLists.forEach(element => {
          (element.questionType = this.type[element.questionType]),
          (element.difficulty = this.difficult[element.difficulty]);
        });
      });
      // this.clearMembers();
    },
    /* 分页 */
    onPageChangeHandler(page) {
      this.page = page;
      this.getQuestionListByPage(this.page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getQuestionListByPage(this.page);
    },
    getQuesPage(id){
      this.page = 1;
      this.getImportQuestionList(id);
    },
    /* 设置选中行 */
    handleSelectionChangeDialog(val) {
      this.setData = [];
      val.forEach(element => {
        this.setData.push(element.Id);
      });
      this.$emit('update:setData', this.setData);
      // this.checkRow = val;
    },
    /* 默认是否已选中 */
    // checkboxInit(row, index) {
    //   let IsExit = this.exitIds.indexOf(row.Id) >= 0;
    //   if (IsExit) { return 0; } // 不可勾选
    //   else return 1; // 可勾选
    // },
    checkAll() {
      this.checkbtn = true;
      this.checkedbtn = !this.checkbtn;
    },
    RemoveAllcheck() {
      this.checkedbtn = true;
      this.checkbtn = !this.checkedbtn;
    },
    // 返回按钮
    btnGoBack() {
      // this.isGoBack=!this.isGoBack;
      this.$emit('parentSchool', this.isNumber);
    }
  },
  mounted() {
    this.clickCourseName=localStorage.getItem('courseName');
  }
};
</script>

<style lang="scss">
.yk-qw-content {
  .manger-import-div{
    .btn-back{
      float: left;
      height: 42px;
      line-height: 42px;
      margin-left: 7px;
      cursor: pointer;
      margin-right: -8px;
    }
  }
  .el-container {
    .el-aside {
      .yk-el-aside {
        .yk-qu-con {
          display: flex;
          justify-content: space-between;
          padding: 13px 15px;
          border-bottom: 1px solid #f5f5f5;
          vertical-align: center;
          cursor: pointer;
          span,
          .yk-title {
            display: inline-block;
          }
          .yk-title {
            padding: 0 5px;
            text-align: center;
            min-width: 140px;
          }
          &:hover {
            background-color: #409eff;
          }
        }
        .active {
          background-color: #409eff;
          color: white;
        }
        .yk-add-group {
          margin-top: 20px;
          margin-bottom: 10px;
          text-align: center;
          cursor: pointer;
          font-size: 17px;
          color: #009688;
          i {
            font-weight: bolder;
            color: #409eff;
          }
        }
      }
    }
    .el-main {
      .yk-main-head {
        .yk-que-name {
          display: flex;
          float: left;
          .el-dropdown {
            .el-dropdown-link {
              font-size: 20px;
            }
          }
          .test-name {
            margin-right: 10px;
          }
          i:hover {
            cursor: pointer;
          }
          i {
            margin-left: 10px;
          }
        }
        .yk-que-config {
          float: right;
        }
        &:after {
          display: block;
          height: 0px;
          content: '';
          clear: both;
        }
      }
      .yk-main-que-content {
        padding-bottom: 5px;
        // border-bottom: 2px solid #f5f5f5;
        .yk-que-con:first-child {
          margin-top: 0px;
        }
        .yk-que-con {
          margin-top: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #d7d7d7;
          .yk-que-head {
            .yk-que-head-info {
              float: left;
              .que-type,
              .diff-type {
                margin-left: 10px;
              }
            }
            .yk-que-head-operate {
              float: right;
              .el-icon-more {
                margin: 0 20px;
                font-size: 17px;
                transform: rotate(90deg);
                -ms-transform: rotate(90deg);
                -moz-transform: rotate(90deg);
                -webkit-transform: rotate(90deg);
                -o-transform: rotate(90deg);
              }
            }
            &:after {
              display: block;
              height: 0;
              content: '';
              clear: both;
            }
          }
          .yk-que-opotion {
            margin-top: 10px;
            ul {
              list-style: none;
              li {
                margin-top: 10px;
                span:first-child {
                  margin-right: 10px;
                  font-weight: bolder;
                }
              }
            }
          }
        }
      }
      .el-pagination {
        text-align: center;
      }
      .el-table__row:nth-child(even) {
        background-color: #ffffff;
      }
      .el-table__row:nth-child(odd) {
        background-color: #fafafa;
      }
      .el-table {
        margin-top: 20px;
        thead {
          tr th {
            background-color: #e9eff5;
          }
        }
      }
    }
    .yk-dialogCon {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1000;
      background-color: rgba(0, 0, 0, 0.4);
      .yk-choiceCon {
        padding: 0 0 20px;
        position: absolute;
        overflow: auto;
        left: 50%;
        top: 50px;
        margin-left: -370px;
        width: 740px;
        height: 500px;
        background-color: white;
        .yk-add-group {
          position: fixed;
          padding: 5px 0;
          width: 740px;
          left: 50%;
          margin-left: -370px;
          z-index: 1000;
          background-color: #409eff;
          span {
            margin: 0 20px;
            color: white;
            font-size: 16px;
          }
          .el-icon-close {
            position: absolute;
            top: 10px;
            right: 10px;
            color: white;
            font-size: 25px;
            font-weight: bolder;
            cursor: pointer;
          }
        }
      }

      &.slide-enter-active,
      &.slide-leave-active {
        transition: all 0.4s;
        background-color: rgba(0, 0, 0, 0);
      }
      .yk-choice-main {
        margin-top: 60px;
      }
    }
    .yk-que-detail {
      .yk-que-choice {
        ul {
          list-style: none;
          li {
            span:first-child {
              font-weight: bolder;
            }
            span:last-child {
              margin-left: 10px;
              color: gray;
            }
          }
        }
      }
      .yk-que-type {
        padding: 10px 0;
        span:last-child {
          margin-left: 10px;
        }
      }
      .yk-que-head {
        font-weight: bolder;
      }
    }
    .el-checkbox__inner {
      border: 2px solid #409eff;
    }
  }
}
</style>
